module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAGJJREFUGBljYEAC////twFhJCFUJlByCwijiAIF2IFYB4gTgfgfFIPYIDF2BiDRB8S4QC/YNKDsNCwqpsGtAkoKYVEgBFLABFWlAaUfAmkQBgGwGEyBFFCgHCoIkgCxQWIMAKYeeIoDK3IuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/icons/atoms/star_icon_white/star_filled_small_turquese_centered.png
// module id = 480
// module chunks = 0